import { createApp } from 'vue';
import ElementPlus from 'element-plus';

export default {
  install: app => {
    // 創建組件實例
    const mountNode = document.createElement('div');
    document.body.appendChild(mountNode);

    let instance = null;

    // 在全局屬性上添加方法
    app.config.globalProperties.$modalReject = async ({
      callback,
      id,
      chapterId = undefined,
      type,
    }) => {
      if (!instance) {
        const { default: modalPatchAuthors } = await import('./index.vue'); // ✅ 動態載入
        const componentApp = createApp(modalPatchAuthors);
        componentApp.use(ElementPlus);
        instance = componentApp.mount(mountNode);
      }

      instance.visible = true;
      if (id) {
        instance.id = id;
      }
      if (callback) {
        instance.callback = callback;
      }
      if (chapterId) {
        instance.chapterId = chapterId;
      }
      if (type) {
        instance.type = type;
      }
      instance.init(id, chapterId);
    };
  },
};
